export const DOCTOR_TYPE_GENERAL_DOCTOR = 'General Doctor'
export const DOCTOR_TYPE_PSYCHOLOGIST = 'PSYCHOLOGIST'
export const DOCTOR_TYPE_VETERINARIAN = 'VETERINARIAN'
export const DOCTOR_TYPE_MIDWIFE = 'MIDWIFE'
